/**
 * SurveyRequest Status label
 */
angular.module('elogbooksDirectives').directive('quoteStatusLabel', ['$http', 'apiClient', '$state', function ($http, apiClient, $state) {
    return {
        restrict: 'AE',
        scope: {
            status: '=ngModel'
        },
        templateUrl: '/modules/directives/quotes/details/elements/status/status.html'
    };
}]);
